function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.25a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0V2A.75.75 0 018 1.25zm8 0a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0V2a.75.75 0 01.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.5 8.37v8.76c0 .16-.01.32-.02.47H2.52c-.01-.15-.02-.31-.02-.47V8.37A4.87 4.87 0 017.37 3.5h9.26a4.87 4.87 0 014.87 4.87z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.48 17.6a4.876 4.876 0 01-4.85 4.4H7.37c-2.53 0-4.61-1.93-4.85-4.4h18.96zm-7.95-5.98c.45-.31.73-.77.73-1.39 0-1.3-1.04-1.97-2.26-1.97-1.22 0-2.27.67-2.27 1.97 0 .62.29 1.09.73 1.39-.61.36-.96.94-.96 1.62 0 1.24.95 2.01 2.5 2.01 1.54 0 2.5-.77 2.5-2.01 0-.68-.35-1.27-.97-1.62zM12 9.5c.52 0 .9.29.9.79 0 .49-.38.8-.9.8s-.9-.31-.9-.8c0-.5.38-.79.9-.79zm0 4.5c-.66 0-1.14-.33-1.14-.93 0-.6.48-.92 1.14-.92.66 0 1.14.33 1.14.92 0 .6-.48.93-1.14.93z"
})));